import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const RegistrationWrapper = styled.div`
  margin: 0 auto;
  max-width: ${pxToRem(400)};
  padding: ${pxToRem(20)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background-color: ${({ theme }) => theme.colors.whiteHex};
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const VerificationHint = styled.p`
  width: 100%;
  max-width: ${pxToRem(369)};
  margin: ${({ theme }) => pxToRem(-theme.spacing.sm)} auto ${({ theme }) => pxToRem(theme.spacing.lg)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
  text-align: left;

  strong {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 500;
  }
`;